import { ref } from 'vue';

// Re-auth overlay state (Angular AuthenticationService.loginLayerIsOpen$ / loginLayerResult).
// Module-level singletons so the router guard (opener) and the KgrReAuthLayer overlay share state.
const isOpen = ref(false);
let pending: Promise<boolean> | null = null;
let resolveFn: ((success: boolean) => void) | null = null;

export function useReAuth() {
    // Open the overlay and return a promise resolving on the login result (Angular layerLogin()).
    // Concurrent callers while already open share the same pending promise.
    function open(): Promise<boolean> {
        if (!isOpen.value) {
            isOpen.value = true;
            pending = new Promise<boolean>((resolve) => {
                resolveFn = resolve;
            });
        }
        return pending!;
    }

    // Close the overlay and notify the awaiter (Angular loginLayerResult.next + the auto-close
    // subscription that flips loginLayerIsOpen$ back to false).
    function resolve(success: boolean) {
        if (!isOpen.value) {
            return;
        }
        isOpen.value = false;
        resolveFn?.(success);
        resolveFn = null;
        pending = null;
    }

    return { isOpen, open, resolve };
}
